module.exports = __webpack_public_path__ + "fonts/font-icon-Enerdata.5242062.woff";